interface Props {
  providerType: string
  config: Record<string, unknown>
  onChange: (config: Record<string, unknown>) => void
}

export default function ClientIoTConfig({ providerType, config, onChange }: Props) {
  const set = (key: string, value: string) => {
    onChange({ ...config, [key]: value })
  }

  if (providerType === 'thingsboard') {
    return (
      <>
        <div className="admin-form__field">
          <label>Customer ID (ThingsBoard)</label>
          <input
            type="text"
            value={(config.customer_id as string) ?? ''}
            onChange={(e) => set('customer_id', e.target.value)}
          />
        </div>
        <div className="admin-form__field">
          <label>Customer Name</label>
          <input
            type="text"
            value={(config.customer_name as string) ?? ''}
            onChange={(e) => set('customer_name', e.target.value)}
          />
        </div>
      </>
    )
  }

  if (providerType === 'luxnavix') {
    return (
      <>
        <div className="admin-form__field">
          <label>API Key (LuxNavix)</label>
          <input
            type="text"
            value={(config.api_key as string) ?? ''}
            onChange={(e) => set('api_key', e.target.value)}
          />
        </div>
        <div className="admin-form__field">
          <label>Site ID</label>
          <input
            type="text"
            value={(config.site_id as string) ?? ''}
            onChange={(e) => set('site_id', e.target.value)}
          />
        </div>
      </>
    )
  }

  return (
    <div className="admin-form__field">
      <label>Config JSON</label>
      <textarea
        className="admin-json-editor"
        value={JSON.stringify(config, null, 2)}
        onChange={(e) => {
          try { onChange(JSON.parse(e.target.value)) } catch { /* invalid json */ }
        }}
        rows={4}
      />
    </div>
  )
}
